import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import useProps from '../use-props';
import {
    Cartesian3,
    Math as CesiumMath,
    JulianDate,
    ClockRange,
    ClockStep,
} from 'cesium';
import { useUpdateEffect } from 'ahooks';

const CircleFly = (props) => {
    const {map} = useProps();

    const {data, height, speed, angle, play} = props;

    const playRef = useRef(play);
    useUpdateEffect(() => {
        map.clock.shouldAnimate = play
        playRef.current = play;
    }, [play]);

    useEffect(() => {
        const distance = height || 15000;
        const seconds = speed || 15;
        const [lon, lat] = data;

        const position = Cartesian3.fromDegrees(lon, lat, 0);

        const pitch = CesiumMath.toRadians(angle || -45);
        const _angle = 360 / seconds;

        const startTime = JulianDate.fromDate(new Date());
        const stopTime = JulianDate.addSeconds(startTime, Infinity, new JulianDate());
        map.clock.startTime = startTime.clone();  // 开始时间
        map.clock.stopTime = stopTime.clone();    // 结速时间
        map.clock.currentTime = startTime.clone(); // 当前时间
        map.clock.clockRange = ClockRange.CLAMPED; // 行为方式
        map.clock.clockStep = ClockStep.SYSTEM_CLOCK; // 时钟设置为当前系统时间; 忽略所有其他设置。
        map.clock.shouldAnimate = play;

        const startHeading = map.camera.heading;

        const timeExecution = () => {
            if (playRef.current) {
                const delTime = JulianDate.secondsDifference(map.clock.currentTime, map.clock.startTime)
                const heading = CesiumMath.toRadians(delTime * _angle) + startHeading
                map.scene.camera.setView({
                    destination: position,
                    orientation: {
                        heading: heading,
                        pitch: pitch
                    }
                })
                map.scene.camera.moveBackward(distance);
                if (JulianDate.compare(map.clock.currentTime, map.clock.stopTime) >= 0) {
                    map.clock.onTick.removeEventListener(timeExecution);
                }
            }
        }

        map.scene.postRender.addEventListener(timeExecution);

        return () => {
            map.scene.postRender.removeEventListener(timeExecution);
        }
    }, []);

    return (
        <></>
    )
}

CircleFly.propTypes = {
    data: PropTypes.array,
    height: PropTypes.number,
    speed: PropTypes.number,
    angle: PropTypes.number,
    play: PropTypes.bool,
}

export default CircleFly;
